export enum TimelineAssetTabs {
  ALL_EVENTS = 'all-events',
  SOURCE_FILES = 'source-files',
}

export const getTimelineAssetTabName = (tab: TimelineAssetTabs) => {
  switch (tab) {
    case TimelineAssetTabs.ALL_EVENTS:
      return 'All Events'
    case TimelineAssetTabs.SOURCE_FILES:
      return 'Source Files'
  }
}

export enum TimelineAssetRouteSegments {
  ADD_FILES = 'add-files',
}

// Update polling backs off 5s -> 10s -> 15s while a run is active.
export const kTimelineAssetPollIntervalsMs = [5000, 10000, 15000]

export const kTimelineAssetAcceptedFileTypes = {
  'application/pdf': ['.pdf'],
}

// Dedicated matter subfolder for timeline direct uploads (mirrors MED_CHRON_FOLDER_NAME).
export const TIMELINE_FOLDER_NAME = 'Timeline'

// Per-file pipeline state for the Add Files cards. EXTRACTED is reserved for read-only rosters;
// the in-flight upload cards only ever surface the other four (see get-timeline-asset-file-card-state).
export enum TimelineFileStatus {
  UPLOADING = 'uploading',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  EXTRACTED = 'extracted',
  ERROR = 'error',
}
